import type { TimetableGridEntry } from './typesV2'

export type WarningLevel = 'error' | 'warning' | 'ok' | 'cancelled'

export function getEntryWarningLevel(entry: TimetableGridEntry, mode?: 'import' | 'dashboard'): WarningLevel {
  if (entry.is_cancelled) {
    return 'cancelled'
  }
  if (mode === 'dashboard') {
    if (!entry.subject || !entry.room || !entry.class_name) {
      return 'warning'
    }
    return 'ok'
  }
  if (!entry.teacher_code || !entry.day_of_week || !entry.time_slot_label) {
    return 'error'
  }
  if (!entry.subject || !entry.room || !entry.class_name) {
    return 'warning'
  }
  return 'ok'
}

export const ENTRY_FIELD_COLORS = {
  teacher_code: { bg: 'bg-blue-50', text: 'text-blue-700' },
  subject: { bg: 'bg-green-50', text: 'text-green-700' },
  room: { bg: 'bg-yellow-50', text: 'text-yellow-700' },
  class_name: { bg: 'bg-orange-50', text: 'text-orange-700' },
}

export const CANCELLED_ENTRY_STYLE = 'opacity-50 line-through text-gray-500'
